import { SectionActionTypeName, SectionActionTypes } from './actionTypes';
import { ISectionsState } from './store';
import { getEmptySection } from './types';

export const initialSectionsState: ISectionsState = {
  filterTypes: [],
  sections: [],
  industryInfo: [],
  sectionDetail: getEmptySection(),
  loading: false,
  commited: false,
};

export const sectionReducer = (
  state: ISectionsState = initialSectionsState,
  action: SectionActionTypes
): ISectionsState => {
  switch (action.type) {
    case SectionActionTypeName.ADD_SECTION_REQUEST:
    case SectionActionTypeName.FETCH_ALL_REQUEST:
    case SectionActionTypeName.DELETE_SECTION_REQUEST:
    case SectionActionTypeName.UPDATE_SECTION_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SectionActionTypeName.ADD_SECTION_SUCCESS:
    case SectionActionTypeName.FETCH_ALL_FAIL:
    case SectionActionTypeName.ADD_SECTION_FAIL:
    case SectionActionTypeName.FETCH_SECTION_DETAIL_FAIL:
      return {
        ...state,
        loading: false,
      };
    case SectionActionTypeName.FETCH_ALL_SUCCESS:
      return {
        ...state,
        loading: false,
        filterTypes: action.filterType,
        sections: action.sections,
        industryInfo: action.industryInfo,
        commited: undefined,
        message: undefined,
        status: undefined,
      };
    case SectionActionTypeName.DELETE_SECTION_SUCCESS:
    case SectionActionTypeName.UPDATE_SECTION_DETAIL_SUCCESS:
      return {
        ...state,
        status: action.status,
        message: action.message,
        commited: action.commited,
        loading: false,
      };
    case SectionActionTypeName.DELETE_SECTION_FAIL:
      return {
        ...state,
        status: action.status,
        loading: false,
      };

    case SectionActionTypeName.UPDATE_SECTION_DETAIL_FAIL:
      return {
        ...state,
        status: action.status,
        message: action.message,
        loading: false,
      };
    case SectionActionTypeName.FETCH_SECTION_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
        sectionDetail: getEmptySection(),
      };
    case SectionActionTypeName.FETCH_SECTION_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        sectionDetail: action.section,
      };
    default:
      return state;
  }
};
